import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Body, Title, Typography } from "@vds/typography";
import { Button } from "@vds/buttons";
import { Icon } from "@vds/icons";
import ManualCameraRtspUrl from "./manualCameraRtspUrl";
import { unsubscribeCameraCVApplicationEndPoint } from "../../../configuration";
import CameraInfoTable2 from "../../../global/components/Tables/CameraInfoTable2";
import axiosInstance from "../../../global/axiosInterceptor";

const CameraStreamList = ({
  cameraData,
  cameraCVAppList,
  setSavedSubscribedCvApps,
  isDeleteModalOpen,
  isManualAdded,
  companions,
  liveFeedList,
  defaultLicenseType,
  setLiveFeedList,
  onFetchSubscribedCvAppsError
}) => {
  const dispatch = useDispatch();

  const { activeSession } = useSelector(
    (state) => state.sessionReducer.activeSession
  );

  const camDetails = cameraData ? cameraData : "";

  const [tableData1, setTableData1] = useState([]);
  const [associateCvAppLoading, setAssociateCvAppLoading] = useState(false);
  const [rtspData, setRtspData] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  // const [savedSubscribedCvApps, setSavedSubscribedCvApps] = useState({});
  const [channelInfo, updateChannelInfo] = useState({ name: "" });
  const [selectedTable, setSelectedTable] = useState();
  const [deviceCvApps, setDeviceCvApps] = useState([]);
  const [loadAssociateCamera, setLoadAssociatedCamera] = useState(false);

  const handleDelete = async (cvAppItem) => {
    try {
      setAssociateCvAppLoading(true);
      const response = await axiosInstance.post(
        unsubscribeCameraCVApplicationEndPoint(),
        {
          accountname: activeSession.accountId,
          resourceidentifier: {
            id: cvAppItem.id,
            deviceid: tableData1[selectedTable].id,
          },
        }
      );
      const res = response.data;
      const status = response.status;
      if (response.status == 200) {
        let resarray = [res];
        sessionStorage.removeItem("cvAppsData", JSON.stringify(resarray));
        const oldDeviceCvApps = [...deviceCvApps];
        if (res?.deviceid) {
          const index = oldDeviceCvApps.findIndex(
            (d) => d.deviceid === res.deviceid
          );
          if (index !== -1) {
            oldDeviceCvApps.splice(index, 1);
          } else {
            oldDeviceCvApps.push(res);
          }
        }
        setDeviceCvApps([oldDeviceCvApps]);
      }

      if (res?.message) {
        setLoadAssociatedCamera((prev) => !prev);
      }
      setAssociateCvAppLoading(false);
    } catch (e) {
      setAssociateCvAppLoading(false);
      console.log(e);
    }
  };
  const storeSubscribedCvAppsData = (data) => {
    setSavedSubscribedCvApps(data);
  };

  return (
    <>
      <ManualCameraRtspUrl
        rtspUrls={rtspData}
        openModal={openModal}
        setOpenModal={setOpenModal}
        cameraDetails={cameraData}
        companionDetails={companions}
      />
      <div className="camera-stream-list__container">
        <div className="camera-stream-list__title-wrapper">
          <div className="camera-stream-list__stream-name">
            <Title size="medium" viewport="desktop">
              Stream details
            </Title>
          </div>
        </div>
        <div className="camera-stream-list__table-scroll">
          <CameraInfoTable2
            cameraDetails={cameraData}
            setTableData1={setTableData1}
            cameraCVAppList={cameraCVAppList}
            handleDelete={handleDelete}
            liveFeedList={liveFeedList}
            defaultLicenseType={defaultLicenseType}
            storeSubscribedCvApps={storeSubscribedCvAppsData}
            isDeleteModalOpen={isDeleteModalOpen}
            setRtspData={setRtspData}
            setOpenModal={setOpenModal}
            isManualAdded={isManualAdded}
            setLiveFeedList={setLiveFeedList}
            onFetchSubscribedCvAppsError={onFetchSubscribedCvAppsError}
          />
        </div>
      </div>
    </>
  );
};

export default CameraStreamList;
